export const social = {
    facebook: {
        label: "Facebook",
        href: "#",
        target: "external",
    },
    instagram: {
        label: "Instagram",
        href: "#",
        target: "external",
    },
    twitter: {
        label: "Twitter",
        href: "#",
        target: "external",
    },
};

export const legal = {
    terms: {
        label: "شروط الاستخدام",
        href: "#",
        target: "external",
    },
    privacy: {
        label: "سياسة الخصوصية",
        href: "#",
        target: "external",
    },
    sell: {
        label: "لا تبيع أو تشارك معلوماتي الشخصية",
        href: "#",
        target: "external",
    },
    choices: {
        label: "اختيارات الإعلان",
        href: "#",
        target: "external",
    },
};

export const a11y = {
    skip: {
        label: "تخطى الى المحتوى",
    },
};
